module.exports = __webpack_public_path__ + "static/img/token-platform-homepage.83a62a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qingye/token-platform-homepage.png
// module id = Cn6V
// module chunks = 1